export default "__VITE_ASSET__BIVRus2d__"